import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Configurator } from "../components/Configurator";
import { useLang } from "../context/LanguageContext";

export default function Vehicles() {
  const { t } = useLang();
  return (
    <div className="bg-white" data-testid="vehicles-page">
      <PageHeader label={t.pages.fleetLabel} title={t.pages.vehiclesTitle} subtitle={t.pages.vehiclesSub} />
      <Configurator embedded />
    </div>
  );
}
